import React, {Suspense, useEffect, useRef} from 'react';

import './css/base.css';
import './css/theme.css';
import './css/layout.css';

import {Routes, Route, useLocation} from 'react-router-dom';
import {Spinner} from 'e3-components';

import ProtectedLayout from './Layout/ProtedtedLayout';
import {useBoundStore} from 'e3-common/store/useBoundStore';
import loadable from '@loadable/component';
import Layout from './Layout/Layout';
import {PAGE_RENDER_TYPE} from 'e3-common/constants/enumerates';
import {componentLoader} from 'e3-common/utils/componentUtil';
import PageContainer from './Layout/PageContainer';
import TabContainer from './Layout/TabContainer';
import {CREATE_TAB_LIST, THEME} from 'e3-common/constants/common';
import useTabMenu from 'e3-common/hooks/useTabMenu';
import {toPayload} from 'e3-common/utils/querystringUtil';
import {setLicenseKey} from '@grapecity/wijmo';
import ProtectedRoute from '@/Layout/ProtectedRoute';
import PasswordCheckPage from '@/Layout/PasswordCheckPage';
import {useIdleTimer} from "e3-common/utils/idleUtil";
import PwChangeForce from "@/pages/PwChangeForce";
import ExpiredCheckRoute from "@/Layout/ExpiredCheckRoute";

const modules = import.meta.glob("pages/**/*.jsx");
const envMode = import.meta.env.MODE == "useLocal" ? true : false;
const programPath = '/Login';
const normalizedPath = programPath.replace(/\/+/g, "/").replace(/^\//, "");
const fullPath = `/src/pages/${normalizedPath}`; // 절대 경로로 변경

const Home = loadable(() => import('./pages/Home'));
const Login = loadable(() => import('./pages/Login'));

function App() {
    setLicenseKey(import.meta.env.VITE_WIJMO_LICENSE);

    const {menuList, pageRenderType} = useBoundStore((state) => state.menu);
    const isMenuListLoaded = menuList.length > 0;
    const location = useLocation();
    const {createTabByNewId} = useTabMenu();
    const user = useBoundStore((state) => state.user);
    const openChk = useRef(false);

    // 세션 시간이 만료되면 로그아웃되는 함수
    useIdleTimer(true);
    useEffect(() => {
        // Check if the location exists,
        // verify if the menuList has been rendered,
        // and ensure that this is excuted only once(openChk .,Ref)
        if (location?.pathname && location?.search && menuList.length && !openChk.current) {
            // the reason for using `openChk` is that when an item is added to `menuList` using `createTabByNewId`. useEffect is triggered.
            openChk.current = true;
            const searchObj = toPayload(location.search);

            // get the location path name and split it..
            const pageNameSplit = location?.pathname?.split('/');
            const pageName = pageNameSplit?.[pageNameSplit?.length - 1];

            // get the location information for create tab
            const key = searchObj?.key;

            // muse be excuted for the defined list only. it is `movePageName`
            // if there are other cases for moving the page, you need to add them to `CREATE_TAB_LIST`
            const movePageName = CREATE_TAB_LIST.find((item) => pageName?.includes(item));

            if (movePageName && key) {
                // create tab
                createTabByNewId([key], movePageName, searchObj);
            }
        }
    }, [menuList]);

    useEffect(() => {
        if (user?.propStr1) {
            document.body.classList = [user?.propStr1];
        } else {
            document.body.classList = [THEME.DEFAULT];
        }
    }, [user]);

    const renderMenuRoutes = () => {
        if (pageRenderType === 'PAGE_RENDER_TYPE.PAGE') {
            return (
                menuList.map((menuItem) => {
                    if (menuItem.programPath) {
                        const Component = componentLoader(menuItem.programPath);
                        return (
                            <Route
                                key={menuItem.menuId}
                                path={
                                    import.meta.env.VITE_PUBLIC_URL +
                                    menuItem.programRoutePath
                                }
                                element={
                                    // menuItem.sideYn === 'Y' ? (
                                    <ProtectedLayout>
                                        <PageContainer
                                            menuName={menuItem.menuName}
                                            menuId={menuItem.menuId}
                                            helpYn={menuItem.helpYn}
                                            menuNameList={menuItem.menuNameList}
                                        >
                                            <Component/>
                                        </PageContainer>
                                    </ProtectedLayout>
                                    // ) : (
                                    //   <Component />
                                    // )
                                }
                            />
                        );
                    }
                })
            )
        } else if (pageRenderType === PAGE_RENDER_TYPE.TAB) {
            menuList
                .filter(menuItem => menuItem.programPath && menuItem.programPath.includes('System'))
                .map(menuItem => {
                    const Component = componentLoader(menuItem.programPath);
                    const subPath = menuItem.programRoutePath.replace(/^\/?System\//i, '');
                    return (
                        <>
                            <Route
                                path={subPath}
                                element={<TabContainer/>}
                            />
                        </>
                    );
                })
        }
        return null;
    }

    return (
        // Routing 설정
        <Suspense>
            <ExpiredCheckRoute>
                <Routes>
                    <Route path={`${import.meta.env.VITE_PUBLIC_URL}/pwChange`} element={<PwChangeForce/>}/>
                    <Route path={import.meta.env.VITE_PUBLIC_URL} element={<Layout/>}>
                        <Route
                            path={import.meta.env.VITE_PUBLIC_URL + '/login'}
                            element={<Login/>}
                        />
                        <Route element={<ProtectedRoute/>}>
                            {pageRenderType === PAGE_RENDER_TYPE.PAGE ? (
                                <Route
                                    index
                                    element={<Home/>}
                                />
                            ) : null}
                            {pageRenderType === PAGE_RENDER_TYPE.TAB ? (
                                <>
                                    <Route
                                        path={import.meta.env.VITE_PUBLIC_URL + '/'}
                                        element={<TabContainer/>}
                                    />
                                    <Route
                                        path={import.meta.env.VITE_PUBLIC_URL + '/*'}
                                        element={<TabContainer/>}
                                    />
                                </>
                            ) : null}
                            {renderMenuRoutes()}
                        </Route>
                    </Route>
                </Routes>
            </ExpiredCheckRoute>
        </Suspense>
    );
}

export default App;
